export enum RVAccountingMethod {
  ACCRUALS = 'accruals',
  CASH = 'cash',
}
